var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.0273C23 9.75286 22.3255 7.52946 21.0619 5.63829C19.7983 3.74713 18.0022 2.27314 15.9009 1.40273C13.7995 0.532327 11.4872 0.304588 9.25647 0.748318C7.02568 1.19205 4.97658 2.28732 3.36828 3.89562C1.75997 5.50392 0.664704 7.55303 0.220974 9.78381C-0.222756 12.0146 0.00498278 14.3269 0.875391 16.4282C1.7458 18.5296 3.21978 20.3256 5.11095 21.5892C7.00211 22.8529 9.22552 23.5273 11.5 23.5273C11.5683 23.5273 11.6365 23.5273 11.7048 23.5226V14.5744H9.23413V11.695H11.7048V9.57447C11.7048 7.1175 13.2062 5.77845 15.397 5.77845C16.1368 5.77514 16.8761 5.81274 17.6117 5.89106V8.46064H16.1C14.9097 8.46064 14.6756 9.02643 14.6756 9.8577V11.6902H17.5285L17.1558 14.5696H14.6736V23.083C17.0733 22.3935 19.1834 20.9419 20.6855 18.9475C22.1875 16.9531 22.9999 14.5241 23 12.0273Z",
    fill: "#B4BCD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.f9eb7e873ae8a276fdb73e55d381c204.svg";
export { ForwardRef as ReactComponent };